module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reviews"
    }
  }, [_c('heading', {
    attrs: {
      "text": _vm.$t('categories.reviews'),
      "level": 2,
      "font": "astonished",
      "color": "red"
    }
  }), _vm._v(" "), _c('list', {
    ref: "list",
    attrs: {
      "scroll": true,
      "items": _vm.reviews,
      "link": "review",
      "fields": ['album', 'band', 'author', 'date'],
      "type": "img"
    },
    on: {
      "update": _vm.load
    }
  }), _vm._v(" "), (_vm.$loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fef7a90"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/router-views/webzine/Reviews.vue
// module id = 267
// module chunks = 0